import { Breadcrumb, BreadcrumbLink } from "components/common/Breadcrumb";
import DataTable from "components/common/DataTable";
import DataTableApiResponse from "interfaces/DataTableApiResponse";
import JobSummary from "interfaces/JobSummary";
import * as moment from "moment";
import * as React from "react";
import { RouteComponentProps } from "react-router";
import { Link } from "react-router-dom";
import getBaseUrl from "utils/getBaseUrl";
import ContentLoading from "components/common/ContentLoading";
import "./Index.css";

interface State {
    data: JobSummary[];
    spinner: boolean;
}

export default class IndexBc extends React.Component<
    RouteComponentProps<{}>,
    State
> {
    private baseUrl: string;
    private dataTableRef: React.RefObject<HTMLTableElement>;

    constructor(props: RouteComponentProps<{}>) {
        super(props);

        this.state = {
            data: [],
            spinner: true,
        };

        this.baseUrl = getBaseUrl();
        this.dataTableRef = React.createRef();

        this.dataTableData = this.dataTableData.bind(this);
        this.dataTableDataFilter = this.dataTableDataFilter.bind(this);
        this.handleDataTableDraw = this.handleDataTableDraw.bind(this);
    }

    public render() {
        return (
            <div className="container">
                <div className="animated fadeIn">
                    <Breadcrumb>
                        <BreadcrumbLink to="/">Home</BreadcrumbLink>
                        <BreadcrumbLink isActive={true}>Projects</BreadcrumbLink>
                    </Breadcrumb>
                    <div className="card card--datatables">
                        <div className="card-block">
                            <h2 className="card__title">Business Central Projects</h2>
                            <div className="datatable-wrapper">
                                <DataTable
                                    ajaxUrl={this.baseUrl + "api/jobs/1/summary"}
                                    useAuth={true}
                                    ajaxData={this.dataTableData}
                                    ajaxDataFilter={this.dataTableDataFilter}
                                    onDraw={this.handleDataTableDraw}
                                    order={[[0, "desc"]]}
                                    stateSave={true}
                                >
                                    <thead>
                                        <tr>
                                            <th style={{ width: "15%" }}>ID</th>
                                            <th style={{ width: "10%" }}>Code</th>
                                            <th style={{ width: "30%" }}>Project Name</th>
                                            <th style={{ width: "30%" }}>Customer Name</th>
                                            <th style={{ width: "10%" }}>Address</th>
                                            <th style={{ width: "10%" }}>Address 2</th>
                                            <th style={{ width: "10%" }}>City</th>
                                            <th style={{ width: "5%" }}>State</th>
                                            <th style={{ width: "10%" }}>Zip</th>
                                            <th style={{ width: "10%" }}>Phone</th>
                                            <th style={{ width: "10%" }}>Contact</th>
                                        </tr>
                                    </thead>
                                    <tbody></tbody>
                                </DataTable>
                                {this.state.spinner ? (
                                    <ContentLoading />
                                ) : (
                                    <table className="d-none" ref={this.dataTableRef}>
                                        <tbody>
                                            {this.state.data.map((item, index) => (
                                                <tr key={item.id}
                                                    id={`row-${item.id}`}
                                                >
                                                    <td>{item.id}</td>
                                                    <td>
                                                        {item.code}
                                                    </td>
                                                    <td>
                                                        {item.name}
                                                    </td>
                                                    <td>{item.customerName}</td>
                                                    {/*<td>{item.address}</td>*/}
                                                    {/*<td>{item.address2}</td>*/}
                                                    {/*<td>{item.city}</td>*/}
                                                    {/*<td>{item.state}</td>*/}
                                                    {/*<td>{item.zip}</td>*/}
                                                    <td>{item.customerAddress}</td>
                                                    <td>{item.customerAddress2}</td>
                                                    <td>{item.customerCity}</td>
                                                    <td>{item.customerState}</td>
                                                    <td>{item.customerZip}</td>
                                                    <td>{item.customerPhoneNo}</td>
                                                    <td>{item.contact}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    public async componentDidMount() {
        document.title = "Projects - " + SITE_NAME;
    }

    private dataTableData(data: any) {
        let sortFields = [
            "id",
            "code",
            "name",
            "customerName",
            "customerAddress",
            "customerAddress2",
            "customerCity",
            "customerState",
            "customerZip",
            "customerPhoneNo",
            "contact",
        ];

        let newData = {
            pageNumber: Math.floor(data.start / data.length) + 1,
            pageSize: data.length,
            sortField: sortFields[data.order[0].column],
            sortDirection: data.order[0].dir === "asc" ? 1 : 2,
            search: data.search.value,
            draw: data.draw,
        };

        return newData;
    }

    private dataTableDataFilter(data: string) {
        var json = JSON.parse(data) as DataTableApiResponse<JobSummary>;

        this.setState({
            data: json.items,
            spinner: false,
        });

        let tableData = [];
        let $tr = $(this.dataTableRef.current!).find("tr");
        for (let i = 0; i < $tr.length; i++) {
            let $td = $tr.eq(i).find("td");
            let rowData = [];
            for (let j = 0; j < $td.length; j++) {
                rowData.push($td.eq(j).clone(true, true).html());
            }
            tableData.push(rowData);
        }

        let newData = {
            draw: json.draw,
            recordTotal: json.metadata.totalItemCount,
            recordsFiltered: json.metadata.totalItemCount,
            data: tableData,
        };

        return JSON.stringify(newData);
    }

    //private handleDataTableDraw(dataTable: any) {
    //    $(dataTable)
    //        .find("a:not([href='#'])")
    //        .click((e) => {
    //            e.preventDefault();
    //            this.props.history.push($(e.currentTarget).attr("href")!);
    //        });
    //}

    private handleDataTableDraw(dataTable: any) {
        $(dataTable).off("click", "tr");
        $(dataTable).find("a:not([href='#'])").off("click");
        $(dataTable)
            .find("tbody tr")
            .css("cursor", "pointer"); 

        $(dataTable)
            .find("a:not([href='#'])")
            .on("click", (e) => {
                e.preventDefault();
                this.props.history.push($(e.currentTarget).attr("href")!);
            });

        $(dataTable).on("click", "tr", (e) => {
            const rowId = $(e.currentTarget).find("td").first().text().trim(); 
            if (rowId) {
                this.props.history.push(`/jobs-bc/${rowId}`);
            }
        });

/*        $(dataTable).DataTable().columns.adjust().draw(false);*/
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/Projects/Index-BC.tsx